<template>
  <div class="progress-level">
    <div class="level-list" v-for="(item, index) in list" :key="index + '_progress'">
      <Texts grayDark xsmallSize class="level-title">{{ item.title }}</Texts>
      <div class="level-process" :class="[`color-level-${item.level}`]" />
      <Texts :grey="item.level * 1 !== 4" :warning="item.level * 1 === 4" xsmallSize class="level-result">{{
        levels[item.level] || '未测'
      }}</Texts>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProgressLevel',
  data() {
    return {
      levels: {
        1: '优秀',
        2: '良好',
        3: '及格',
        4: '落后'
      }
    };
  },
  props: {
    list: {
      type: Array,
      default: () => {
        return [];
      }
    }
  }
};
</script>

<style lang="less" scoped>
@colors: #90ee6b, #76bdfe, #ffd759, #ff777b;
.color-level(@n, @data, @i: 1) when (@i =< @n) {
  @color: extract(@data, @i);
  .color-level-@{i}::after {
    content: '';
    display: block;
    height: 100%;
    border-radius: 12px;
    width: ((@n - @i + 1) * 100% / @n);
    background-color: @color;
  }
  .color-level(@n, @data, (@i + 1));
}
.level-list {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .level-result,
  .level-title {
    flex: 0 0 auto;
  }
  .level-title {
    width: 114px;
  }
  .level-process {
    position: relative;
    width: 420px;
    height: 14px;
    margin: 0 24px;
    border-radius: 12px;
    overflow: hidden;
    background-color: #f5f6fa;
  }
  .color-level(4, @colors);
  & + & {
    margin-top: 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ProgressLevel/index.vue